import type { Platform } from '../context/env-context';

// NOTE: the Shopify date is only for BFS review and will be removed once we get the badge
const BFS_REVIEW_SUBMISSION_DATE = new Date('2026-08-18T14:00:00Z');

/**
 * When each platform started managing SparkLayer inside its own admin. A platform is left out until
 * it does, and adding one is a single entry here rather than another platform check at every use.
 */
const MANAGED_IN_PLATFORM_ADMIN_FROM: Partial<Record<Platform, Date>> = {
  shopify: BFS_REVIEW_SUBMISSION_DATE,
  shopify_plus: BFS_REVIEW_SUBMISSION_DATE,
};

/**
 * Whether a store set up at `installedAt` manages SparkLayer in its platform's own admin, in which
 * case the dashboard sends it there instead of rendering its own pages.
 */
export function isManagedInPlatformAdmin(platform?: Platform, installedAt?: string | Date) {
  const managedFrom = platform ? MANAGED_IN_PLATFORM_ADMIN_FROM[platform] : undefined;
  if (!managedFrom || !installedAt) {
    return false;
  }

  const installedAtTime = new Date(installedAt).getTime();

  return !Number.isNaN(installedAtTime) && installedAtTime >= managedFrom.getTime();
}
